<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('crudTiposEquipamentos.messages.systemMessage') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                this.messageDismissButton }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
                this.messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <merus-data-table :headers="headers" :items="tiposEquipamentos" :mostrar-inativos="mostrarInativos" :search="search" :loading="loadingtable"
      :loading-text="$t('crudTiposEquipamentos.loading')" dense class="elevation-7"
      locale="pt" style="border-radius: 10px" :default-multi-sort="defaultSort"

 cod-tabela="TIPOSEQUIPAMENTOS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <cadastro-toolbar :title="$t('crudTiposEquipamentos.title')" :token="token" :items="tiposEquipamentosFiltrados"
          csv-title="tipos_equipamentos" @search="search = $event">
          <template v-slot:extension>
            <v-switch
              v-model="mostrarInativos"
              :label="$t('crudVeiculos.showInactive')"
              class="ml-3 mr-4"
              hide-details
            ></v-switch>
          </template>
          <template v-slot:add>
            <v-dialog v-model="dialog" max-width="100%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-toolbar dark color="primary" ref="myToolbar">
                  <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row style="padding-top: 10px;" justify="center">
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.nome_tipo_equipamento"
                            :label="$t('crudTiposEquipamentos.form.fields.nome')"
                            :rules="[nomeRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.categoria_tipo_equipamento"
                            :label="$t('crudTiposEquipamentos.form.fields.categoria')"
                            clearable></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-select v-model="editedItem.id_unidade_equipamento" :items="unidadesEquipamentos"
                            item-text="nome_unidade_equipamento" item-value="id_unidade_equipamento"
                            :label="$t('crudTiposEquipamentos.form.fields.unidade')" clearable></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="4"></v-col>
                        <v-col cols="12" sm="1" md="1">
                          <v-switch v-model="editedItemInventariavel" class="ma-2"
                            :label="$t('crudTiposEquipamentos.form.fields.inventariavel')"
                            color="primary"></v-switch>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="12" sm="1" md="1">
                          <v-switch v-model="editedItemAtivo" class="ma-2"
                            :label="$t('crudTiposEquipamentos.form.fields.ativo')"
                            color="primary"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="4" md="4"></v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </cadastro-toolbar>
      </template>
      <template v-slot:item.ativo="{ item }">
        <v-chip small :color="item.ativo === 1 || item.ativo === true ? 'green' : 'grey'" dark>
          {{ item.ativo === 1 || item.ativo === true ? $t('crudTiposEquipamentos.activeYes') : $t('crudTiposEquipamentos.activeNo') }}
        </v-chip>
      </template>
      <template v-slot:item.pode_editar="{ item }">
        <v-chip small :color="item.pode_editar === 1 || item.pode_editar === true ? 'green' : 'grey'" dark>
          {{ item.pode_editar === 1 || item.pode_editar === true ? $t('crudTiposEquipamentos.activeYes') : $t('crudTiposEquipamentos.activeNo') }}
        </v-chip>
      </template>
      <template v-slot:item.inventariavel="{ item }">
        <v-chip small :color="item.inventariavel === 1 || item.inventariavel === true ? 'green' : 'grey'" dark>
          {{ item.inventariavel === 1 || item.inventariavel === true ? $t('crudTiposEquipamentos.activeYes') : $t('crudTiposEquipamentos.activeNo') }}
        </v-chip>
      </template>
      <template v-slot:item.nome_unidade_equipamento="{ item }">
        {{ item.nome_unidade_equipamento || '—' }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon v-if="item.pode_editar === 1 || item.pode_editar === true" small class="mr-2" color="green" @click="editItem(item)">mdi-pencil</v-icon>
        <span v-else class="grey--text text--darken-1" style="font-size: 0.75rem">—</span>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import { validador } from "@/constants";
import EventBus from "@/utils/eventBus";
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
  },
  data: () => ({
    headers: [],
    user: null,
    token: null,
    showConfirmButton: true,
    formValidado: true,
    dialog: false,
    operacao: 0,
    confirmDialog: false,
    mensagemdialog: "",
    loadingtable: true,
    search: "",
    mostrarInativos: false,
    tiposEquipamentos: [],
    editedIndex: -1,
    editedItem: {
      id_tipo_equipamento: null,
      nome_tipo_equipamento: null,
      categoria_tipo_equipamento: null,
      ativo: true,
      pode_editar: false,
      inventariavel: false,
      id_unidade_equipamento: null,
    },
    deletedItem: {
      id_tipo_equipamento: null,
      nome_tipo_equipamento: null,
      categoria_tipo_equipamento: null,
      ativo: null,
      pode_editar: null,
      inventariavel: null,
      id_unidade_equipamento: null,
    },
    defaultItem: {
      id_tipo_equipamento: null,
      nome_tipo_equipamento: null,
      categoria_tipo_equipamento: null,
      ativo: true,
      pode_editar: false,
      inventariavel: false,
      id_unidade_equipamento: null,
    },
    unidadesEquipamentos: [],
  }),
  computed: {
    tiposEquipamentosFiltrados() {
      if (!this.mostrarInativos) {
        return this.tiposEquipamentos.filter((t) => t.ativo === true || t.ativo === 1);
      }
      return this.tiposEquipamentos;
    },
    messageDismissButton() { return this.$t('button.dismiss'); },
    messageConfirmButton() { return this.$t('button.confirm'); },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('crudTiposEquipamentos.form.title.create')
        : this.$t('crudTiposEquipamentos.form.title.edit');
    },editedItemAtivo: {
      get() {
        return this.editedItem.ativo === 1 || this.editedItem.ativo === true;
      },
      set(val) {
        this.editedItem.ativo = val;
      },
    },
    editedItemPodeEditar: {
      get() {
        return this.editedItem.pode_editar === 1 || this.editedItem.pode_editar === true;
      },
      set(val) {
        this.editedItem.pode_editar = val;
      },
    },
    editedItemInventariavel: {
      get() {
        return this.editedItem.inventariavel === 1 || this.editedItem.inventariavel === true;
      },
      set(val) {
        this.editedItem.inventariavel = val;
      },
    },
    defaultSort() {
      return [
        { value: 'nome_tipo_equipamento', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaTiposEquipamentos();
    this.populaUnidadesEquipamentos();
  },
  mounted() { },
  methods: {

    nomeRules() {
      if (!validador(this.editedItem.nome_tipo_equipamento, 1, 100, 1, 1)) {
        return this.$t('crudTiposEquipamentos.form.validation.nameRequired');
      }
      return true;
    },
    populaTiposEquipamentos() {
      apiController.request(apiController.endpoints.getallTiposequipamentos, {
        onSuccess: (response) => {
          this.tiposEquipamentos = response.data || [];
          this.loadingtable = false;
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    populaUnidadesEquipamentos() {
      apiController.request(apiController.endpoints.getallUnidadesequipamentos, {
        silent: true,
        onSuccess: (response) => {
          this.unidadesEquipamentos = Array.isArray(response.data) ? response.data : [];
        },
        onError: () => {
          this.unidadesEquipamentos = [];
        },
      });
    },
    editItem(item) {
      if (item.pode_editar !== 1 && item.pode_editar !== true) {
        EventBus.$emit('show-alert', { mensagem: this.$t('crudTiposEquipamentos.cannotEdit'), tipo: 'warning' });
        return;
      }
      this.editedIndex = this.tiposEquipamentos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.ativo = item.ativo === 1 || item.ativo === true;
      this.editedItem.pode_editar = item.pode_editar === 1 || item.pode_editar === true;
      this.editedItem.inventariavel = item.inventariavel === 1 || item.inventariavel === true;
      this.editedItem.id_unidade_equipamento = item.id_unidade_equipamento || null;
      this.dialog = true;
    },
    toggleAtivo(item) {
      const newAtivo = !(item.ativo === 1 || item.ativo === true);
      apiController.request(apiController.endpoints.updateTipoequipamento, {
        data: {
          id_tipo_equipamento: item.id_tipo_equipamento,
          ativo: newAtivo,
        },
        onSuccess: (response) => {
          if (response.data.erro) {
            EventBus.$emit('show-alert', { mensagem: this.$t('crudTiposEquipamentos.messages.errorUpdate'), tipo: 'error' });
          } else {
            EventBus.$emit('show-alert', {
              mensagem: newAtivo ? this.$t('crudTiposEquipamentos.messages.activatedSuccess') : this.$t('crudTiposEquipamentos.messages.deactivatedSuccess'),
              tipo: 'success',
            });
          }
          this.populaTiposEquipamentos();
        },
      });
    },
    deleteFromDatabase() {
      this.confirmDialog = false;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.deletedItem.ativo = null;
        this.editedIndex = -1;
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
    save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        const payload = {
          nome_tipo_equipamento: this.editedItem.nome_tipo_equipamento,
          categoria_tipo_equipamento: this.editedItem.categoria_tipo_equipamento || null,
          ativo: this.editedItem.ativo === 1 || this.editedItem.ativo === true ? 1 : 0,
          pode_editar: this.editedItem.pode_editar === 1 || this.editedItem.pode_editar === true ? 1 : 0,
          inventariavel: this.editedItem.inventariavel === 1 || this.editedItem.inventariavel === true ? 1 : 0,
          id_unidade_equipamento: this.editedItem.id_unidade_equipamento || null,
        };
        if (this.editedIndex === -1) {
          this.operacao = 0;
          apiController.request(apiController.endpoints.insertTipoequipamento, {
            data: payload,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        } else {
          payload.id_tipo_equipamento = this.editedItem.id_tipo_equipamento;
          payload.ativo = this.editedItem.ativo === 1 || this.editedItem.ativo === true ? 1 : 0;
          this.operacao = 1;
          apiController.request(apiController.endpoints.updateTipoequipamento, {
            data: payload,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        }
      }
    },
    updateTable(status) {
      let mensagem = "";
      const tipo = status ? "error" : "success";

      if (status) {
        if (this.operacao === 0) {
          mensagem = this.$t('crudTiposEquipamentos.messages.errorInclusion');
        } else if (this.operacao === 1) {
          mensagem = this.$t('crudTiposEquipamentos.messages.errorUpdate');
        } else {
          mensagem = this.$t('crudTiposEquipamentos.messages.errorDeletion');
        }
      } else {
        if (this.operacao === 0) {
          mensagem = this.$t('crudTiposEquipamentos.messages.includedSuccess');
        } else if (this.operacao === 1) {
          mensagem = this.$t('crudTiposEquipamentos.messages.updatedSuccess');
        } else {
          mensagem = this.$t('crudTiposEquipamentos.messages.deletedSuccess');
        }
        this.editedItem = Object.assign({}, this.defaultItem);
      }

      EventBus.$emit('show-alert', { mensagem, tipo });
      this.close();
      this.populaTiposEquipamentos();
    },
  },
};
</script>
